

define(['squid/index'], function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xomodel.credit', ['squid']).factory('$CreditDataModel', function ($Model, $Api, $util) {

        return $Model.extend('CreditDataModel', {
            init: function init() {
                this._super.init.apply(this);
                this.setProperties({
                    flow_type: $util.param('flow'),
                    cape_key: $util.param('key'),
                    cape_success: $util.param('success'),
                    credit_signup: $util.param('creditSignup'),
                    userAction: $util.param('action'),
                    merchantAction: $util.param('merchantAction'),
                    credit_login_failure: false,
                    cape_service_error: $util.param('isInternalServiceError'),
                    cape_redirect_uri: '',
                    change_installment: $util.param('changeStatus'),
                    nextState: ''
                });
            },

            api: new $Api({
                uri: '/api/credit/:id/creditData',
                postAttempts: 2
            }),

            isCreditSignup: function isCreditSignup() {
                return this.credit_signup && this.credit_signup === 'true';
            },

            setCapeRedirectUri: function setCapeRedirectUri(input) {
                this.cape_redirect_uri = input;
            },

            getCapeRedirectUri: function getCapeRedirectUri() {
                return this.cape_redirect_uri;
            },

            getMerchantAction: function getMerchantAction() {
                return this.merchantAction || '';
            },

            setCreditSignup: function setCreditSignup(input) {
                this.credit_signup = input;
            },

            getCapeKey: function getCapeKey() {
                return this.cape_key;
            },

            getFlow: function getFlow() {
                if (this.userAction === 'addCredit') {
                    return 'credit';
                }
                return this.flow_type;
            },
            setFlow: function setFlow(flowType) {
                this.flow_type = flowType;
            },

            setNextState: function setNextState(nextState) {
                this.nextState = nextState;
            },

            isCapeSuccess: function isCapeSuccess() {
                return this.cape_success && this.cape_success === 'true';
            },

            isCreditTxn: function isCreditTxn() {
                return this.flow_type && this.flow_type === 'credit' || this.userAction && this.userAction === 'addCredit';
            },

            setCreditLoginFailure: function setCreditLoginFailure(input) {
                this.credit_login_failure = input;
            },

            getCreditLoginFailure: function getCreditLoginFailure() {
                return this.credit_login_failure;
            },

            isCapeReturn: function isCapeReturn() {
                return this.flow_type && this.flow_type === 'capeReturn';
            },

            isCapeInternalServiceError: function isCapeInternalServiceError() {
                return this.cape_service_error && this.cape_service_error === 'true';
            },

            getNextState: function getNextState() {
                return this.nextState;
            },

            isChangeStatus: function isChangeStatus() {
                return this.change_installment === 'changeInstallment';
            },

            isRedirectFromCape: function isRedirectFromCape() {
                return Boolean(this.cape_key && this.cape_success === 'true' || $util.param('applyCredit'));
            }
        });
    }).factory('$CreditInstallmentModel', function ($Model, $Api) {

        return $Model.extend('CreditInstallmentModel', {
            api: new $Api({
                uri: '/api/checkout/:id/creditOptions/'
            })
        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-models/src/credit/index.js
// module id = ./components/xo-models/src/credit/index.js
// module chunks = 1